import { render, staticRenderFns } from "./SelectRoleDialog.vue?vue&type=template&id=46625556&scoped=true&"
import script from "./SelectRoleDialog.vue?vue&type=script&lang=js&"
export * from "./SelectRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoleDialog.vue?vue&type=style&index=0&id=46625556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46625556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46625556')) {
      api.createRecord('46625556', component.options)
    } else {
      api.reload('46625556', component.options)
    }
    module.hot.accept("./SelectRoleDialog.vue?vue&type=template&id=46625556&scoped=true&", function () {
      api.rerender('46625556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/account/dialogs/SelectRoleDialog.vue"
export default component.exports